import React from 'react'

const Redo = ({ className, size, disabled }) => {
  return (
    <svg
      width={`${size ? size : '31'}`}
      height={`${size ? size : '31'}`}
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        r="15.5"
        transform="matrix(-1 0 0 1 15.5 15.5)"
        fill="#3D3D3D"
        fillOpacity={disabled ? '0.3' : '0.96'}
      />
      <path
        d="M18.4326 13.5391C17.6668 12.838 16.2993 11.9752 15.1541 11.9752C12.8003 11.9752 10.8921 13.7957 10.8921 16.0415C10.8921 18.2872 12.8003 20.1078 15.1541 20.1078C16.2993 20.1078 17.339 19.6769 18.1048 18.9757M18.4326 13.5391L17.4491 10.0537M18.4326 13.5391L15.482 14.0753"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default Redo
